// 通用
export default {
  com_hi: 'Hi',
  com_welcome: 'Welcome',
  // 操作类型
  com_operationTypes: [
    {
      name: 'Newly',
      value: 0,
    },
    {
      name: 'Edit',
      value: 1,
    },
    {
      name: 'Delete',
      value: 2,
    },
    {
      name: 'Disabled',
      value: 3,
    },
    {
      name: 'Enabled',
      value: 4,
    },
    // 未知
    {
      name: '--',
      value: 9,
    },
  ],

  // header
  com_header_title: '',
  com_header_help: 'Docs',
  com_header_account: 'Account',
  com_header_logout: 'Logout',
  com_header_document: 'MBE Wiki',
  com_header_setting: 'System Manage',
  com_header_message: 'Notification',
  com_header_logout_confirm_text: 'Confirm to log out? ',
  com_header_logout_timeout: 'Login has timed out',
  com_header_station: 'Site',
  com_header_device: 'Device',
  com_header_docs: 'MBE Wiki',
  com_header_search_result1: 'Search ',
  com_header_search_result2: ', total ',
  com_header_search_result3: ' records',
  com_header_search_placeholder: 'Please enter site/device/document keywords',

  // 菜单
  com_sider_menu_welcome: 'Welcome',
  com_sider_menu_home: 'Home',
  // site
  com_sider_menu_site: 'Site',
  com_sider_menu_site_add: 'Add New Site',
  com_sider_menu_site_edit: 'Edit Site',
  com_sider_menu_site_detail: 'Site Detail',
  // device
  com_sider_menu_device: 'Device',
  com_sider_menu_device_list: 'Device List',
  com_sider_menu_device_add: 'Add Device',
  com_sider_menu_device_edit: 'Edit Device',
  com_sider_menu_device_detail: 'Device Detail',
  com_sider_menu_device_terminal: 'Device Terminal',
  // issue
  com_sider_menu_issue: 'Issue Track',
  com_sider_menu_issue_list: 'Issue List',
  com_sider_menu_issue_add: 'Add Issue',
  com_sider_menu_issue_edit: 'Edit Issue',
  com_sider_menu_issue_add_anonymous: 'Add Anonymous Issue',
  com_sider_menu_issue_detail: 'Issue Detail',

  com_sider_menu_system: 'System',
  com_sider_menu_system_welcome: 'Welcome',
  com_sider_menu_system_dashboard: 'System',
  com_sider_menu_and_interface: 'Menu And Interface',
  // customer
  com_sider_menu_customer: 'Customer',
  com_sider_menu_customer_add: 'Add New Customer',
  com_sider_menu_customer_edit: 'Edit Customer',
  com_sider_menu_customer_detail: 'Customer Detail',
  // user
  com_sider_menu_user: 'User',
  com_sider_menu_user_add: 'Add New User',
  com_sider_menu_user_edit: 'Edit User',
  com_sider_menu_user_auth: 'User Authorization',
  com_sider_menu_user_detail: 'User Detail',
  // role
  com_sider_menu_role: 'Role',
  com_sider_menu_role_add: 'Add New Role',
  com_sider_menu_role_edit: 'Edit Role',
  com_sider_menu_role_auth_menu: 'Menu Authorization',
  com_sider_menu_role_auth_data: 'Data Authorization',

  com_sider_menu_model: 'Device Model',
  com_sider_menu_model_alias: 'Device Model Alias',
  // config model
  com_sider_menu_config: 'Data Model',
  com_sider_menu_config_list: 'Data Model List',
  com_sider_menu_config_add: 'Add Data Model',
  com_sider_menu_config_edit: 'Edit Data Model',
  com_sider_menu_config_group: 'Data Model Group',
  // docs
  com_sider_menu_docs: 'Documents',
  com_sider_menu_docs_list: 'Documents List',
  com_sider_menu_docs_search: 'Search Document',
  com_sider_menu_docs_add: 'Add Document',
  com_sider_menu_docs_edit: 'Edit Document',
  // logs
  com_sider_menu_logs: 'Logs Manage',
  com_sider_menu_logs_action: 'Action Logs',
  com_sider_menu_logs_protocol: 'Protocol Logs',
  com_sider_menu_logs_error: 'Error Logs',

  com_sider_menu_no_auth: 'No Auth',
  com_sider_menu_my: 'My Information',
  com_sider_menu_black: 'Black Device List',

  // 分页
  com_pagination_total: 'Total number',

  // 报错提示
  com_error_network: 'Network abnormality',
  com_error_network_description: 'Current network abnormality, please try again later',
  com_error_404: '404 Not Found',
  com_error_404_descriptoin: 'Sorry, the page you visited does not exist',
  com_error_forbidden: '403 Forbidden',
  com_error_forbidden_description:
    'Sorry, you do not have permission to access this page. Please contact the creator via WeChat Enterprise',
  com_error_500: 'System error, please try again later',
  com_error_net: 'The network is busy, please try again later',
  com_api_error_404: 'API not found',

  // 提示
  com_msg_empty: 'No Data',
  com_msg_connect_pending: 'Connecting...',
  com_msg_connect: 'Connect',
  com_msg_success: 'Successfully',
  com_msg_fail: 'Failed',
  com_msg_timeout: 'Time out',
  com_msg_add_success: 'Add Successfully',
  com_msg_add_fail: 'Add Failed',
  com_msg_edit_success: 'Edit Successfully',
  com_msg_edit_fail: 'Edit Failed',
  com_msg_delete_success: 'Delete Successfully',
  com_msg_delete_fail: 'Delete Failed',
  com_msg_maintenance_success: 'Maintenance Successfully',
  com_msg_maintenance_fail: 'Maintenance Failed',
  com_msg_save_success: 'Save Successfully',
  com_msg_save_fail: 'Save Failed',
  com_msg_copy_success: 'Copy Successfully',
  com_msg_copy_fail: 'Copy Failed',
  com_msg_disabled_success: 'Disabled Successfully',
  com_msg_enabled_success: 'Enabled Successfully',
  com_msg_refresh_success: 'Refresh Successfully',
  com_msg_refresh_fail: 'Refresh Failed',
  com_msg_close_success: 'Close Successfully',
  com_msg_reopen_success: 'Reopen Successfully',
  com_msg_fork_success: 'Fork Successfully',
  com_msg_data_auth_success: 'Data Authorization Successfully',
  com_msg_select_item_first: 'Please select item first',
  com_msg_select_group_first: 'Please select group first',
  com_msg_select_params_first: 'Please select params first',
  com_msg_not_be_empty: 'Value cannot be empty',
  com_msg_not_ok: 'The value is invalid or format error',
  com_msg_selected: 'Selected',
  com_msg_error: 'Error',
  com_msg_result: 'Result',

  // network error
  com_network_error: 'Sorry, Network Error!',
  com_network_please: 'Please',
  com_network_retry: 'retry',
  com_network_later: 'later',

  // no auth
  com_no_auth_tip1: 'You do not have permission.',
  com_no_auth_tip2: 'Please contact the administrator if necessary!',

  // 按钮
  com_btn_reload: 'Reload',
  com_btn_return_home: 'Return Home',
  com_btn_login: 'Login',
  com_btn_edit: 'Edit',
  com_btn_edit_content: 'Edit Content',
  com_btn_edit_prop: 'Edit Property',
  com_btn_add: 'Add',
  com_btn_add_device: 'Add Device',
  com_btn_fork: 'Fork',
  com_btn_delete: 'Delete',
  com_btn_delete_batch: 'Batch Delete',
  com_btn_back: 'Back',
  com_btn_cancel: 'Cancel',
  com_btn_cancel_edit: 'Cancel Edit',
  com_btn_enabled: 'Enable',
  com_btn_disabled: 'Disabled',
  com_btn_reset: 'Reset',
  com_btn_search: 'Search',
  com_btn_search_folder: 'Search Current Folder',
  com_btn_search_global: 'Global Search',
  com_btn_iknown: 'I known',
  com_btn_more: 'More',
  com_btn_lock: 'locked',
  com_btn_unlock: 'Unlock',
  com_btn_detail: 'Detail',
  com_btn_submit: 'Submit',
  com_btn_connect: 'Connect',
  com_btn_disconnect: 'Disconnect',
  com_btn_refresh: 'Refresh',
  com_btn_excute: 'Excute',
  com_btn_finish: 'Finish',
  com_btn_confirm: 'Comfrim',
  com_btn_remove: 'Remove',
  com_btn_save: 'Save',
  com_btn_create: 'Create',
  com_btn_close: 'Close',
  com_btn_download: 'Download',
  com_btn_share: 'Share',
  com_btn_set: 'Set',
  com_btn_copy: 'Copy',
  com_btn_auth: 'Authorization',
  com_btn_webui: 'WEBUI',
  com_btn_ssh: 'SSH',
  com_btn_close_vpn: 'Close VPN',
  com_btn_other: 'Other',
  com_btn_other_control: 'Other Control',
  com_btn_export: 'Export',
  com_btn_import: 'Import',
  com_btn_import_value: 'Import Value',
  com_btn_comment: 'Comment',
  com_btn_comment_and_close: 'Comment & Close Issue',
  com_btn_user_add: 'Add New User',
  com_btn_user_manage: 'Manage User',
  com_btn_customer_manage: 'Manage Customer',
  com_btn_device_model_manage: 'Manage Device Model',
  com_btn_lookfor: 'Search',
  com_btn_disabled2: 'Disable',
  com_btn_enabled2: 'Enable',
  com_btn_expand: 'Expand',
  com_btn_collapse: 'Collapse',
  com_btn_new: 'New',
  com_btn_update: 'Update',
  com_btn_upload_image: 'Upload Image',
  com_btn_insert_image: 'Upload and Insert Image',
  com_btn_insert_image_btn: 'Insert Image',
  com_btn_insert_video: 'Insert Video',
  com_btn_upload_video: 'Upload Video',
  com_btn_get_share_file: 'Get File',
  com_btn_destroy: 'Destory',
  com_btn_logout: 'Logout',

  // 过程
  com_ongoing_delete: 'delete...',
  com_ongoing_enable: 'enable...',
  com_ongoing_disable: 'disable...',
  com_ongoing_save: 'save...',
  com_ongoing_update: 'update...',
  com_ongoing_close_vpn: 'closing vpn...',
  com_ongoing_remove: 'remove...',
  com_ongoing_refresh: 'refresh...',

  // 表格
  com_table_index: 'Index',
  com_table_id: 'ID',
  com_table_time: 'Time',
  com_table_created: 'Created',
  com_table_created_time: 'Created Time',
  com_table_created_by: 'Created By',
  com_table_updated: 'Updated',
  com_table_updated_time: 'Updated Time',
  com_table_status: 'Status',
  com_table_user_created: 'User Created',
  com_table_operation: 'Operation',
  com_table_no_data: 'No Data',
  com_table_loading: 'loading...',
  com_table_name: 'Name',
  com_table_code: 'Code',
  com_table_parent_model: 'Parent Model',
  com_table_yes: 'Yes',
  com_table_no: 'No',
  com_table_disabled: 'Disabled',
  com_table_contact: 'Contact',
  com_table_address: 'Address',
  com_table_telephone: 'Telephone',
  com_table_type: 'Type',
  com_table_device_name: 'Device Name',
  com_table_falut_time: 'Fault Time',
  com_table_fault_count: 'Fault Count',
  com_table_action: ' Action',
  com_table_souce: 'Souce',
  com_table_warning_level: 'Warning Level',
  com_table_data: 'Data',
  com_table_check_all: 'All',
  com_table_check_reverse: 'Reverse',
  com_table_alarm_name: 'Alarm Name',

  // 表单
  com_form_all: 'All',
  com_form_area: 'Area',
  com_form_area_all: 'All Area',
  com_form_area_select: 'Please select area',
  com_form_area_region_label: 'Area / Region',
  com_form_region: 'Region',
  com_form_region_all: 'All Region',
  com_form_region_select: 'Please select region',
  com_form_region_area_label: 'Region / Area',
  com_form_upload_image_error: 'Please upload image',
  com_video_not_support:
    'Your browser does not support HTML5 video, please upgrade or change the browser.',

  com_form_name: 'Name',
  com_form_keyword_input: 'Please input keywords',
  com_form_enabled: 'Enabled',
  com_form_enabled_label: 'Is Enabled',
  com_form_enabled_success: 'Enabled Successfully',
  com_form_enabled_fail: 'Enabled Failed',
  com_form_disabled: 'Disabled',
  com_form_status_all: 'All Status',
  com_form_input_placeholder: 'Please input',
  com_form_select_placeholder: 'Please select',
  com_form_description: 'Description',
  com_form_description_placeholder: 'Please input description',
  com_form_remark: 'Remark',
  com_form_remark_placeholder: 'Please input remark',
  com_form_attachment: 'Attachment',
  com_form_attachment_download: 'Download Attachment',
  com_form_order_field: 'Order Field',
  com_form_order_desc: 'DESC',
  com_form_order_esc: 'ESC',
  com_form_password_help:
    '8-32 bits, must contain large and small letters, numbers and special characters',
  com_form_url: 'URL',
  com_form_name_placeholder: 'Please input name',
  com_form_fault_code_placeholder: 'Please input fault code',
  com_form_warning_name_placeholder: 'Please input warning name',
  com_form_device_name_placeholder: 'Please input device name',
  com_form_device_param_name_placeholder: 'Please input search keywords, such as parameters',
  com_form_device_ctrl_placeholder: 'Please input search keywords, such as control parameters',
  com_form_device_operation_placeholder: 'Please input search keywords, such as data',
  com_form_device_param_event_placeholder: 'Please input search keywords, such as name/data/user',
  com_form_device_fault_placeholder: 'Please input search keywords, such as fault name',

  // 表单验证
  // 整型
  com_form_type_integer: 'Integer',
  com_form_validate_type_integer: 'Only integer number',
  com_form_validate_type_integer_min_max: 'Only integer number, min: {min}, max: {max}',
  com_form_validate_type_integer_range_help:
    'The format is: 0~100, 0 is the minimum value, 100 is the maximum value. For example -10~10, -10~-5, 0~10, etc. Do not fill in means no scope.',
  com_form_validate_type_integer_range_error1: 'The format incorrect, the correct such as: 0~100',
  com_form_validate_type_integer_range_error2:
    'The format incorrect, the value before the ~ symbol must be less than the value after.',
  // 浮点型
  com_form_type_float: 'Float',
  com_form_validate_type_float: 'Only floating number',
  com_form_validate_type_float_min_max:
    'Only floating number , min: {min}, max: {max}, decimal: {decimal}',
  com_form_validate_type_float_range_help:
    'The format is: 0~100|2, 0 is the minimum value, 100 is the maximum value, 2 is the decimal point to be reserved, and the maximum decimal point is 99. Do not fill in means no scope.',
  com_form_validate_type_float_range_error1:
    'The format is incorrect, the correct such as: 0~100|22, the maximum number of decimal places is 99.',
  com_form_validate_type_float_range_error2:
    'The format incorrect, the value before the ~ symbol must be less than the value after.',
  // 字符串型
  com_form_type_string: 'String',
  com_form_validate_type_string: 'Only string',
  com_form_validate_type_string_min_max: 'Only string , min length: {min}, max length: {max}',
  com_form_validate_type_string_help:
    'The format is: 0~100, 0 is the minimum input length, 100 is the maximum input length. Do not fill in means no scope',
  com_form_validate_type_string_error1:
    'The format is incorrect, the correct such as: 0~100, only numbers, separated by ~',
  com_form_validate_type_string_error2:
    'The format incorrect, the value before the ~ symbol must be less than the value after.',
  // 枚举型
  com_form_type_enumeration: 'Enumeration',
  com_form_type_enumeration_help:
    'The format is: "test|1|number", "test" is the display value, "1" the value, "number" is the type (the default type is String  when not filled in, only three types of number, string, and boolean are supported), multiple line feeds.',
  com_form_type_enumeration_error1:
    'The format of line {index} is incorrect, such as: abc|123, cannot contain multiple vertical bars',
  com_form_type_enumeration_error2:
    'The format of line {index} is incorrect, such as: Type only supports number, string, boolean',

  com_form_contact: 'Contact Info',
  com_form_contact_placeholder: 'Please input contact info',
  com_form_contact_person: 'Contact',
  com_form_contact_person_placeholder: 'Please input contact',
  com_form_telephone: 'Telephone',
  com_form_telephone_placeholder: 'Please input telephone',
  com_form_address: 'Address',
  com_form_address_placeholder: 'Please input address',

  // 上传
  com_upload_tip1: 'Click or drag file to this area to upload',
  com_upload_only_text: 'Only',
  com_upload_tip3: 'not more than',
  com_upload_size_error: 'File size cannot exceed {maxSize}',
  com_upload_type_error: 'Only {typeList} can be uploaded',
  com_upload_btn: 'Click to Upload',
  com_upload_image: 'Click to Upload Image',
  com_upload_json_tip: 'Only JSON can be uploaded, not more than 5M.',
  com_upload_support_type: 'Support',
  com_upload_tip: 'Only accept file:',
  com_upload_tip_video: 'Click or drag video file to this area to upload',
  com_upload_select_file: 'Select File',
  com_upload_filename_error:
    'The file name must be: {filename},current file name is: {currentFilename}',
  com_upload_filename_error2: '',

  // IP地点
  com_location_default: 'China|GuangDongSheng|ShenZhen，N/A',

  // 时间
  com_time_day: 'Day',
  com_time_week: 'Week',
  com_time_month: 'Month',
  com_time_year: 'Year',
  com_time_custom: 'Custom',
  com_time_hour: 'Hour',
  com_time_min: 'Min',
  com_time_minute: 'Minute',
  com_time_second: 'Second',
  com_time_d: 'd',
  com_time_h: 'h',
  com_time_m: 'm',
  com_time_s: 's',

  // 故障
  com_fault_all: 'All',
  com_fault_ma: 'MA',
  com_fault_ca: 'CA',
  com_fault_oa: 'OA',
  // 故障类型
  com_fault_type: 'Fault Type',
  com_alarm_type: 'Alarm Type',
  com_fault_type_offline: 'Offline',
  com_fault_type_alarm: 'Alarm',
  com_fault_type_fault: 'Fault',
  com_fault_type_unavailable: 'Error',
  com_fault_current: 'Current Alarm',
  com_fault_history: 'History Alarm',
};
